import * as Autosuggest from 'react-autosuggest'
import * as React from 'react'
import TextFieldProps = __MaterialUI.TextFieldProps
import TextField from 'material-ui/TextField'
import {SuggestionsFetchRequest} from 'react-autosuggest'
import {MessageWithTranslation} from '../../../Entities/MessageWithTranslation.entity.evolve'
import {renderSuggestion, shouldRenderSuggestions} from '../../../View/MaterialAutosuggest'
import {ProductCalculationImportAction} from '../ProductCalculationImportActions'
import {getDisplayedText, getRenderFunctionForMessageSuggestions, getValuedText} from './AutoSuggestionHelper'
import FailedIcon from 'material-ui/svg-icons/content/clear'
import NotFound from 'material-ui/svg-icons/alert/error-outline'
import FoundAndOk from 'material-ui/svg-icons/action/done'

export function ProductCalculationImportAutoSuggestionSelect({
                                                                 dispatch,
                                                                 keyType,
                                                                 label,
                                                                 stateSearchValue,
                                                                 stateSuggestions,
                                                                 stateIdValue,
                                                                 forceChecked,
                                                                 submissionAttempted
                                                             }: {
    dispatch: (action: ProductCalculationImportAction) => void,
    keyType: string,
    label: string,
    stateSearchValue: string,
    stateSuggestions: MessageWithTranslation[],
    stateIdValue: number
    forceChecked: boolean
    submissionAttempted: boolean
}) {
    return (
        <div>
            <div style={{width: 'calc(100% - 64px)', float: 'left'}}>
                <Autosuggest
                    id={keyType}
                    name={keyType}
                    suggestions={stateSuggestions}
                    onSuggestionsFetchRequested={
                        (value: SuggestionsFetchRequest) => {
                            dispatch({
                                type: 'FetchProductCalculationMessageSuggestions',
                                key: keyType,
                                value: value.value,
                            })
                        }}
                    onSuggestionsClearRequested={
                        () => dispatch({
                            type: 'ClearProductCalculationMessageSuggestions',
                            key: keyType
                        })}
                    getSuggestionValue={getValuedText(stateSearchValue)}
                    inputProps={{
                        value: stateSearchValue,
                        onChange: (// tslint:disable-next-line
                            event: any,
                            {newValue}: { newValue: string }) => dispatch({
                            type: 'ProductCalculationMessageSearchChanged',
                            key: keyType,
                            value: newValue,
                        }),
                    }}
                    onSuggestionSelected={
                        (// tslint:disable-next-line
                            event: any,
                            {suggestion}: { suggestion: MessageWithTranslation }) => dispatch({
                            type: 'ProductCalculationMessageChanged',
                            key: keyType,
                            value: suggestion,
                        })}
                    renderInputComponent={
                        (inputProps: TextFieldProps) =>
                            <TextField
                                {...inputProps}
                                floatingLabelText={label}
                                fullWidth={true}
                            />
                    }
                    renderSuggestionsContainer={getRenderFunctionForMessageSuggestions}
                    renderSuggestion={renderSuggestion(getDisplayedText)}
                    shouldRenderSuggestions={shouldRenderSuggestions}
                    allwaysRenderSuggestions={true}
                />
            </div>
            <div style={{width: '64px', float: 'right', paddingTop: '32px', textAlign: 'right'}}>
                {getStatusIcon(stateSearchValue, stateSuggestions, stateIdValue, forceChecked, submissionAttempted)}
            </div>
        </div>
    )
}

function getStatusIcon(searchValue: string,
                       suggestions: MessageWithTranslation[],
                       value: number,
                       forceChecked: boolean,
                       submissionAttempted: boolean) {
    const style = (submissionAttempted) ? {color: 'rgb(244, 67, 54)'} : {}
    if (forceChecked) {
        return <FoundAndOk/>
    }
    if (searchValue === '') {
        return <FailedIcon style={style}/>
    }
    if (value === 0) {
        return <NotFound style={style}/>
    }
    return <FoundAndOk/>

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/ProductCalculationImport/AutoSuggestions/ProductCalculationAutoSuggestionSelect.tsx